<script setup lang="ts">
    import { Button } from '@/components/ui/button';
    import { Minus } from 'lucide-vue-next';
</script>

<template>
    <Button
        variant="ghost_destructive"
        size="xs"
    >
        <span>{{ $t('forms.deactivate') }}</span>
        <Minus class="text-destructive" />
    </Button>
</template>
